var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.026 10.12-7.618 8.094 7.618 8.094a2.27 2.27 0 1 1-3.307 3.113L.636 19.77a2.27 2.27 0 0 1 0-3.113L9.72 7.007a2.27 2.27 0 1 1 3.307 3.113Zm23.942 0a2.27 2.27 0 0 1 3.307-3.113l9.083 9.65a2.27 2.27 0 0 1 0 3.113l-9.083 9.65a2.27 2.27 0 1 1-3.307-3.112l7.618-8.094-7.618-8.094Z",
    fill: "#394A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.699.1a2.27 2.27 0 0 1 1.606 2.78l-8.228 30.708a2.27 2.27 0 1 1-4.387-1.176l8.228-30.707A2.27 2.27 0 0 1 29.699.099",
    fill: "#5298F4"
  }))));
};

export default SvgCode;